<template lang='pug'>
  //- List-Page
  div(:class='$style[`cc-rank-list`]')
    ul(v-if='!preLoading' :class='$style[`cc-rank-list-ul`]')
      li(v-if='isEmpty' :class='$style[`cc-rank-list-li`]')
        span(:class='$style[`cc-rank-list-empty`]')!= '尚無排名'
      //- 選單區
      li(v-for='items, index in dataContainer' :key='index' :class='$style[`cc-rank-list-li`]')
        router-link(
          v-if='items.user_type === `normal`'
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-rank-list-wrap`]'
          :to='{name: `profile`, params: { type: `normal`, id: `${items.auth_id}`}}')
          div(:class='$style[`cc-rank-list-left`]')
            div.font-bold(v-if='index === 0' :class='$style[`cc-rank-list-index`]')
              span(:class='$style[`cc-rank-list-1st`]') {{ index + 1 }}
            div.font-bold(v-else-if='index === 1' :class='$style[`cc-rank-list-index`]')
              span(:class='$style[`cc-rank-list-2st`]') {{ index + 1 }}
            div.font-bold(v-else-if='index === 2' :class='$style[`cc-rank-list-index`]')
              span(:class='$style[`cc-rank-list-3st`]') {{ index + 1 }}
            div.font-bold(v-else :class='$style[`cc-rank-list-index`]')
              span {{ index + 1 }}

            figure(v-if='items.thumbSrc' :class='$style[`cc-rank-list-thumb`]')
              img(
                :src='avatarSrcLink(items.thumbSrc)'
                width='100%' height='100%')
            figure(v-else :class='$style[`cc-rank-list-thumb`]')
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            div(:class='$style[`cc-rank-list-info`]')
              span(v-if='items.public' :class='$style[`cc-rank-list-info-status`]')
                span(:class='$style[`cc-rank-list-info-name`]')
                  span.font-normal-theme.font-medium {{ `${items.firstName}${items.lastName}` }}
                span(:class='$style[`cc-rank-list-info-id`]') {{ `編號 ${items.auth_id}` }}

              span(v-else :class='$style[`cc-rank-list-info-status`]')
                span(:class='$style[`cc-rank-list-info-name`]')
                  span.font-normal-theme.font-medium {{ `${items.firstName}${items.gender === `0` ? `先生` : `小姐`}` }}
                span.bg-normal-theme(v-if='items.auth_id === loginDjangoId' :class='$style[`cc-rank-list-info-iam`]')!= '我本人'
                span(v-else :class='$style[`cc-rank-list-info-id`]') {{ `編號 ${items.auth_id}` }}

          div(:class='$style[`cc-rank-list-right`]')
            span.font-bold {{ items.hp }}
            span(:class='$style[`cc-rank-list-right-hp`]')!= 'HP'

        router-link(
          v-if='items.user_type === `doctor`'
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-rank-list-wrap`]'
          :to='{name: `profile`, params: { type: `doctor`, id: `${items.auth_id}`}}')
          div(:class='$style[`cc-rank-list-left`]')
            div.font-bold(v-if='index === 0' :class='$style[`cc-rank-list-index`]')
              span(:class='$style[`cc-rank-list-1st`]') {{ index + 1 }}
            div.font-bold(v-else-if='index === 1' :class='$style[`cc-rank-list-index`]')
              span(:class='$style[`cc-rank-list-2st`]') {{ index + 1 }}
            div.font-bold(v-else-if='index === 2' :class='$style[`cc-rank-list-index`]')
              span(:class='$style[`cc-rank-list-3st`]') {{ index + 1 }}
            div.font-bold(v-else :class='$style[`cc-rank-list-index`]')
              span {{ index + 1 }}

            figure(v-if='items.thumbSrc' :class='$style[`cc-rank-list-thumb`]')
              img(
                :src='avatarSrcLink(items.thumbSrc)'
                width='100%' height='100%')
            figure(v-else :class='$style[`cc-rank-list-thumb`]')
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            div(:class='$style[`cc-rank-list-info`]')
              span(:class='$style[`cc-rank-list-info-status`]')
                span(:class='$style[`cc-rank-list-info-name`]')
                  span.font-doctor-theme.font-medium {{ `${items.firstName}${items.lastName}` }}
                span.bg-doctor-theme(v-if='items.auth_id === loginDjangoId' :class='$style[`cc-rank-list-info-iam`]')!= '我本人'
                span(v-else :class='$style[`cc-rank-list-info-id`]') {{ items.character ? `${items.character}` : `` }}

          div(:class='$style[`cc-rank-list-right`]')
            span.font-bold {{ items.hp }}
            span(:class='$style[`cc-rank-list-right-hp`]')!= 'HP'

      div(v-if='loadedComplete && !isEmpty' :class='$style[`cc-infinite-wrap`]')
        infinite-loading(:class='$style[`cc-content-infinite-load`]' :identifier='infiniteId' @infinite='infiniteHandler')
          IconLoading(slot='spinner' :size='30' :color='`#b1b1b1`')
          div.infinite-scroll-slot(slot='no-more')
            span.infinite-scroll-slot-noMore {{ '沒有更多排名' }}

          div.infinite-scroll-slot(slot='no-results')
            span.infinite-scroll-slot-noMore {{ '沒有更多排名' }}


    div(v-else :class='$style[`cc-rank-list-preload`]')
      IconLoading(:size='30' :color='`#b1b1b1`')


</template>

<script>
import { mapGetters } from 'vuex';
import IconRank from '../../icon/Rank';
import IconDoctor from '../../icon/Doctor';
import IconLoading from '../../icon/Loading';

import {
  putRankList,
} from '../../../js/restapi';

export default {
  components: {
    IconRank,
    IconDoctor,
    IconLoading,
  },

  props: {
    listType: {
      type: String,
      default: 'normal',
    },
  },

  data() {
    return {
      preLoading: true,
      loadedComplete: false,
      dataContainer: [],
      isEmpty: false,
      limitNum: 10,
      pageIndex: 1,
      infiniteId: +new Date(),
    };
  },

  created() {
    this.axiosFirstLoadRankList();
  },

  methods: {
    infiniteHandler($state) {
      if (this.loadedComplete) {
        // this.loadedPreload = true;
        const PASS_DATA = {
          size: `${this.limitNum}`,
          page: `${this.pageIndex}`,
          user_type: this.listType,
        };

        putRankList('', PASS_DATA)
          .then((res) => {
            const resData = res.data.results;
            if (!resData.length) {
              // this.loadedPreload = false;
              $state.complete();
              return;
            }

            const getLoadData = new Promise((resolve) => {
              resData.forEach((element) => {
                if (element.hp) {
                  this.dataContainer.push(element);
                }
              });
              return resolve(resData.length);
            });

            getLoadData.then((value) => {
              if (value >= this.limitNum) {
                this.pageIndex += 1;
                // this.loadedPreload = false;
                $state.loaded();
              } else {
                // this.loadedPreload = false;
                $state.complete();
              }
            });
          })
          .catch((err) => {
            console.log('infiniteHandler Error');
          });
      } else {
        // this.loadedPreload = false;
        $state.complete();
      }
    },

    axiosFirstLoadRankList() {
      this.dataContainer = [];
      this.isEmpty = true;

      const PASS_DATA = {
        size: `${this.limitNum}`,
        page: `${this.pageIndex}`,
        user_type: this.listType,
      };

      putRankList('', PASS_DATA)
        .then((response) => {
          console.log('RankList', response.data);
          const resResult = response.data.results;
          if (resResult) {
            resResult.map((x) => {
              if (x.hp) {
                this.dataContainer.push(x);
                this.isEmpty = false;
              }
            });
            this.infiniteId += 1;
            this.pageIndex += 1;
          }
          this.preLoading = false;
          this.loadedComplete = true;
        })
        .catch((/* error */) => {
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // rwdType: 'global/exportRwdType',
      // authJwtToken: 'user/exportUserJwtToken',
      // loginStatus: 'user/exportLoginStatus',
      // loginHashCode: 'user/exportUserHashCode',
      // loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      stateFlowBarFixed: 'global/exportFlowBarFixed',
      // stateIndexBanner: 'global/exportIndexBanner',
      // stateIndexFlowType: 'flow/exportIndexFlowType',
      // stateIndexFilterType: 'flow/exportIndexFilterType',
      // stateIndexFlowArticleData: 'flow/exportIndexFlowTypeArticle',
      // stateIndexFlowResumeData: 'flow/exportIndexFlowTypeResume',
      // stateIndexFlowQaData: 'flow/exportIndexFlowTypeQa',
      // stateIndexFlowTags: 'flow/exportIndexFlowTags',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/rank/rankList.scss';
</style>
